const {Backbone} = require('backboneAdapter');
import Handlebars from 'handlebars';
import Template from 'js/templates/promo.row.hbs';
import TemplateNarrow from 'js/templates/promo.row.narrow.hbs';

require('interfaceAdapter');

export default Backbone.View.extend({
    tagName: 'div',
    className: 'campaignballoon',

    initialize: function (options) {
        this.template = Handlebars.compile(options.narrow ? TemplateNarrow : Template);
        this.model.bind('change', this.render, this);
        this.model.bind('destroy', this.remove, this);
    },

    render: function () {
        this.$el.html(this.template(this.model.toJSON()));
        this.$el.addClass();
        return this;
    }
});
